import ManuallyCredit from './ManuallyCredit';
import {
  creditCardActions,
  savedCreditCardsSel,
  selectedCardSel,
  creditCardErrorSel,
  creditCardSuccessSel,
  creditCardIsPendingSel
} from 'src/store/modules/creditcard';
import {
  IInvoiceCreditPayment,
  IFiltersInvoice,
  IPaginationInvoice
} from 'src/services/invoice/InvoiceService';
import actions from 'src/store/modules/invoices/actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  selectedCreditInvoicesSel,
  selectcreditInvoicedataSel,
  selectedInvoicesSel,
  CreditInvoiceCreditSel,
  manualerrorSel,
  manualsuccessSel,
  invoicesActions,
  CreditInvoiceDebitSel,
  pageNumberSel,
  pageSizeSel,
  totalElementsSel,
  totalPagesSel,
  getInvoicesIsPendingSel,
  invoiceFilterSel
} from 'src/store/modules/invoices';
import { userDataSel, userActions } from 'src/store/modules/user';
const mapStateToprops = (state: any) => ({
  errorPayment: manualerrorSel(state),
  invoiceFilter: invoiceFilterSel(state),
  successPayment: manualsuccessSel(state),
  selectCreditInvoices: selectcreditInvoicedataSel(state),
  selectedInvoices: selectedInvoicesSel(state),
  selectedCreditInvoices: selectedCreditInvoicesSel(state),
  totalCreditmanual: CreditInvoiceCreditSel(state),
  totalDebitmanual: CreditInvoiceDebitSel(state),
  savedCreditCards: savedCreditCardsSel(state),
  selectedCreditCard: selectedCardSel(state),
  creditCardError: creditCardErrorSel(state),
  creditCardSuccess: creditCardSuccessSel(state),
  creditCardIsPending: creditCardIsPendingSel(state),
  userData: userDataSel(state),
  isPending: getInvoicesIsPendingSel(state),
  pagination: {
    pageNumber: pageNumberSel(state),
    pageSize: pageSizeSel(state),
    totalElements: totalElementsSel(state),
    totalPages: totalPagesSel(state),
    getInvoicesIsPending: getInvoicesIsPendingSel(state)
  }
});

const mapDispatchToProps = (dispatch: any) => ({
  getselectCredit: (filters: IFiltersInvoice, pagination: IPaginationInvoice) =>
    dispatch(actions.getselectCredit(filters, pagination)),
  manualApplyCredits: (
    invoicePayments: IInvoiceCreditPayment[],
    signature: string
  ) => {
    dispatch(invoicesActions.manualApplyCredits(invoicePayments, signature));
  },
  clearAlert: () => {
    dispatch(invoicesActions.setError(''));
    dispatch(invoicesActions.setSuccess());
    dispatch(creditCardActions.setError());
    dispatch(creditCardActions.setSuccess());
  },
  getUserDetails: () => {
    dispatch(userActions.getUserDetails());
  }
});

export default connect(
  mapStateToprops,
  mapDispatchToProps
)(withRouter(ManuallyCredit));
